(function AdzukiVideoRecorder($, Adzuki)
{
	const component = {
		emits : ['recorded-video'],
		inject: {
			formatDuration: {
				default: () => undefined
			},
			formatFileSize: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			},
			openAlert: {
				default: () => undefined
			}
		},
		template: '#adzuki-video-recorder',
		data() {
			return {
				file              : null,
				mediaRecorder     : null,
				stream            : null,
				recordedChunks    : [],
				isPreviewActive   : false,
				isRecording       : false,
				isRecordingPaused : false,
				captionsText      : '',
				captionsUrl       : null,
				showCaptions      : false,
				promptText        : '',
				isScrolling       : false,
				isPaused          : false,
				scrollSpeed       : 30,
				scrollInterval    : null,
				currentPosition   : 0,
				defaultFontSize   : 'fs-3',
				recordedVideoUrl  : null,
				displayOrientation: 'horizontal',
				scriptPosition    : 'right',
				helpText          : null,
				showHelpModal     : false
			};
		},
		computed: {
			flexClass() {
				if (this.displayOrientation === 'horizontal' && this.scriptPosition === 'left') {
					return 'flex-row-reverse';
				}
				if (this.displayOrientation === 'vertical' && this.scriptPosition === 'above') {
					return 'flex-column-reverse';
				}
				return '';
			}
		},
		methods: {
			async toggleCamera() {
				if (this.isPreviewActive) {
					if (this.stream) {
						this.stream.getTracks().forEach(track => track.stop());
						this.stream = null;
					}
					this.isPreviewActive = false;
				} else {
					try {
						this.stream = await navigator.mediaDevices.getUserMedia({
							video: true,
							audio: true
						});

						if (this.stream) {
							console.log('Stream started successfully');
							this.$refs.videoPreview.srcObject = this.stream;
							this.$refs.videoPreview.play();
							this.isPreviewActive = true;
						} else {
							console.error('Stream is null.');
						}

					} catch (error) {
						console.error('Error accessing camera:', error);
						this.openAlert('error', 'Error', 'Unable to access camera. Please make sure you have granted permission.');
					}
				}

				this.$nextTick(() => {
					const container = document.getElementById('video-recorder-container');
					if (container) {
						container.scrollIntoView({
							behavior: 'smooth',
							block   : 'start'
						});
					}
				});
			},
			toggleRecording() {
				if (this.isRecording) {
					this.stopRecording();
				} else {
					this.startRecording();
				}
			},
			startRecording() {
				if (!this.stream) {
					return;
				}

				this.mediaRecorder  = new MediaRecorder(this.stream);
				this.recordedChunks = [];

				this.mediaRecorder.ondataavailable = (e) => {
					if (e.data.size > 0) {
						this.recordedChunks.push(e.data);
					}
				};

				this.mediaRecorder.onstop = () => {
					console.log('Recording stopped');

					const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
					this.file = new File([blob], `recording-${Date.now()}.webm`, { type: 'video/webm' });

					this.recordedVideoUrl = URL.createObjectURL(this.file);

					this.isRecording  = false;
					this.showCaptions = true;

					this.$nextTick(() => {
						if (this.$refs.recordedVideoPreview) {
							this.$refs.recordedVideoPreview.src = this.recordedVideoUrl;
							this.$refs.recordedVideoPreview.controls = true;
							this.$refs.recordedVideoPreview.muted = false;
						}
					});

					if (this.stream) {
						this.stream.getTracks().forEach(track => track.stop());
						this.stream = null;
					}
					this.isPreviewActive = false;
				};

				this.mediaRecorder.start();

				this.isRecordingPaused = false;
				this.isRecording = true;

				if (this.promptText !== '') {
					this.startScrolling();
				}
			},
			stopRecording() {
				if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
					this.mediaRecorder.stop();
					this.isRecordingPaused = false;
				}

				this.stopScrolling();

				this.captionsText = this.promptText;

			},
			pauseRecording() {
				if (!this.mediaRecorder) {
					return;
				}

				if (this.mediaRecorder.state === 'recording' && typeof this.mediaRecorder.pause === 'function') {
					this.mediaRecorder.pause();
					this.isRecordingPaused = true;

					if (this.isScrolling && !this.isPaused) {
						this.pauseScrolling();
					}
				}
			},
			resumeRecording() {
				if (!this.mediaRecorder) {
					return;
				}

				if (this.mediaRecorder.state === 'paused' && typeof this.mediaRecorder.resume === 'function') {
					this.mediaRecorder.resume();
					this.isRecordingPaused = false;

					if (this.promptText !== '') {
						this.startScrolling();
					}
				}
			},
			togglePauseRecording() {
				if (!this.mediaRecorder) {
					return;
				}

				if (this.mediaRecorder.state === 'paused') {
					this.resumeRecording();
				} else if (this.mediaRecorder.state === 'recording') {
					this.pauseRecording();
				}
			},
			startScrolling() {
				if (this.isScrolling) {
					return;
				}

				this.isScrolling = true;
				this.isPaused    = false;
				const container  = this.$refs.promptContainer;

				this.scrollInterval = setInterval(() => {
					this.currentPosition += this.scrollSpeed * 0.016;
					container.scrollTop = this.currentPosition;

					if (container.scrollTop >= (container.scrollHeight - container.clientHeight)) {
						this.pauseScrolling();
					}
				}, 16);
			},
			stopScrolling() {
				this.isScrolling     = false;
				this.isPaused        = false;
				this.currentPosition = 0;

				clearInterval(this.scrollInterval);

				this.$refs.promptContainer.scrollTop = 0;
			},
			pauseScrolling() {
				if (this.isPaused) {
					this.isPaused = false;
					this.startScrolling();
				} else {
					this.isPaused = true;
					this.isScrolling = false;
					clearInterval(this.scrollInterval);
				}
			},
			updateFontSize(event) {
				const fontSizes = {
					Smallest: 'fs-5',
					Small   : 'fs-4',
					Medium  : 'fs-3',
					Large   : 'fs-2',
					Largest : 'fs-1',
				};
				this.defaultFontSize = fontSizes[event.target.value];
			},
			updateSpeed(event) {
				const speeds = {
					Slowest: 5,
					Slow   : 15,
					Medium : 30,
					Fast   : 40,
					Fastest: 50,
				};
				this.scrollSpeed = speeds[event.target.value];
			},
			scrollToTop() {
				this.isScrolling = false;
				clearInterval(this.scrollInterval);
				this.$refs.promptContainer.scrollTop = 0;
				this.$nextTick(() => {
					this.currentPosition = 0;
					if (!this.isPaused) {
						this.startScrolling();
					}
				});
			},
			createVTTFile(text, fileName = null) {
				console.log('create vtt file', text);

				const baseFileName = fileName
					? fileName.substring(0, fileName.lastIndexOf('.')) || fileName
					: Date.now().toString();

				const finalFileName = `${baseFileName}_captions.vtt`;

				const words = String(text).split(/\s+/).filter(word => word.length > 0);
				const wordsPerCue         = 10;
				const secondsPerCue       = 4;
				const carryForwardSeconds = 1;

				const chunks = [];
				for (let i = 0; i < words.length; i += wordsPerCue) {
					chunks.push(words.slice(i, i + wordsPerCue).join(' '));
				}

				const cueLines  = [];
				let cueNumber = 1;

				for (let i = 0; i < chunks.length; i++) {
					const currentText = String(chunks[i]).trim();
					const start     = i * secondsPerCue;
					const end       = start + secondsPerCue;

					if (i === 0 || carryForwardSeconds <= 0) {
						cueLines.push([
							String(cueNumber++),
							`${this.formatTime(start)} --> ${this.formatTime(end)} position:0% align:start`,
							currentText,
							''
						].join('\n'));
						continue;
					}

					const transitionEnd = Math.min(start + carryForwardSeconds, end);
					const previousText   = String(chunks[i - 1]).trim();
					const combinedText   = `${previousText}\n${currentText}`.trim();

					cueLines.push([
						String(cueNumber++),
						`${this.formatTime(start)} --> ${this.formatTime(transitionEnd)} position:0% align:start`,
						combinedText,
						''
					].join('\n'));

					// Remainder cue: current only until the original end time
					if (transitionEnd < end) {
						cueLines.push([
							String(cueNumber++),
							`${this.formatTime(transitionEnd)} --> ${this.formatTime(end)} position:0% align:start`,
							currentText,
							''
						].join('\n'));
					}
				}

				const vttContent = `WEBVTT\n\n${cueLines.join('\n')}`;

				return new File([vttContent], finalFileName, { type: 'text/vtt' });
			},
			formatTime(seconds) {
				const pad = (num) => num.toString().padStart(2, '0');
				const hours = Math.floor(seconds / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const secs = Math.floor(seconds % 60);
				return `${pad(hours)}:${pad(minutes)}:${pad(secs)}.000`;
			},
			async addCaptionsToVideo() {
				if (!this.captionsText.trim()) {
					this.openAlert('error', 'Error', 'Please type in captions to add to your video.');
					return;
				}

				try {
					const captionsFile = this.createVTTFile(this.captionsText, this.file.name);

					this.captionsUrl      = URL.createObjectURL(captionsFile);
					this.file.captions    = captionsFile;
					this.file.captionsUrl = this.captionsUrl;

					// Reset the caption state
					this.recordIndex = null;
					this.showCaptions = false;

					this.openAlert('success', 'Success', 'Captions added successfully');
				} catch (error) {
					this.openAlert('error', 'Error', 'Failed to add captions to the video');
				}
			},
			removeCaptionsFromVideo() {
				this.captionsUrl      = null;
				this.file.captions    = null;
				this.file.captionsUrl = null;
				this.showCaptions     = false;

				this.openAlert('success', 'Success', 'Captions removed successfully');
			},
			attachVideo() {
				this.file.fileOrigin = 'recorded';
				this.$emit('recorded-video', this.file);
				this.rerecord();
				this.promptText = '';
			},
			rerecord() {
				const savedText = this.promptText;

				if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
					try {
						this.mediaRecorder.stop();
					} catch (e) {
						console.error('Error stopping media recorder:', e);
					}
				}

				// Stop camera/mic stream
				if (this.stream) {
					this.stream.getTracks().forEach(track => track.stop());
					this.stream = null;
				}

				// Revoke any object URLs we createdX
				if (this.recordedVideoUrl) {
					URL.revokeObjectURL(this.recordedVideoUrl);
				}

				// Reset component state
				const resetData = this.$options.data();
				Object.assign(this.$data, resetData);

				// Optionally keep the prompt text
				this.promptText = savedText;

				this.$nextTick(() => {
					const clearVideoEl = (el, isStreamEl) => {
						if (!el) {
							return;
						}

						try {
							el.pause();
						} catch (e) {
							console.error('Error pausing video element:', e);
						}

						if (isStreamEl) {
							// Live preview element uses srcObject
							el.srcObject = null;
						}

						el.removeAttribute('src');
						el.load();

						el.controls = false;
						el.muted = true;
					};

					clearVideoEl(this.$refs.videoPreview, true);

					clearVideoEl(this.$refs.recordedVideoPreview, false);
				});
			},
			updateCaptions() {
				this.showCaptions = true;
			},
			toggleOrientation(orientation = null, position = null) {
				this.displayOrientation = orientation ?? this.displayOrientation;
				this.scriptPosition     = position ?? this.scriptPosition;

				sessionStorage.setItem('video-orientation', JSON.stringify({
						orientation: this.displayOrientation,
						position   : this.scriptPosition
					})
				);
			},
			clearPrompt() {
				this.stopScrolling();
				this.isRecordingPaused = false;
				this.isRecording       = false;
				this.promptText        = '';

			},
			async getHelpText() {
				try {
					 const response = await fetch(this.$baseUri + '/Videos/getBrowserInfo');
					 this.helpText = await response.text();
					 this.showHelpModal = true;
				 } catch (error) {
					 console.error('Error fetching help text:', error);
					 this.helpText = 'Error fetching help text. Please try again later.';
				 }
			}
		},
		mounted() {
			let orientation         = JSON.parse(sessionStorage.getItem('video-orientation'));
			this.displayOrientation = orientation?.orientation ?? this.displayOrientation;
			this.scriptPosition     = orientation?.position ?? this.scriptPosition ;
		}
	};


	Adzuki.VueComponents.AdzukiVideoRecorder = component;
}(jQuery, window.Adzuki || {}));
